import React from 'react';
import { Security } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import oktaAuthService from '../../services/auth/oktaAuthService';

// Use the existing Okta Auth instance from oktaAuthService
const oktaAuth = oktaAuthService.getOktaAuth();

const OktaAuthProvider = ({ children }) => {
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    // Navigate to the originalUri or default to '/'
    const relativeUri = toRelativeUrl(
      originalUri || '/',
      window.location.origin
    );
    // Simple redirect without manipulating history to avoid Router conflicts
    window.location.href = relativeUri;
  };

  const onAuthRequired = () => {
    // Redirect to Okta hosted login page
    oktaAuth.signInWithRedirect();
  };

  return (
    <Security
      oktaAuth={oktaAuth}
      onAuthRequired={onAuthRequired}
      restoreOriginalUri={restoreOriginalUri}
    >
      {children}
    </Security>
  );
};

export default OktaAuthProvider;
export { oktaAuthService as oktaAuth };
